import React from 'react';
import { Grid } from '@mui/material';
import { KpiTile, Section, formatBytes, formatCount, sumKnown } from './common';

/** Platform inventory — current totals, independent of the period (handoff §4A). */
const InventoryRow = ({ centers, sources, storageComputedAt }) => {
  const enabled = centers.filter((c) => c.active).length;
  const storage = sumKnown(centers, 'storageBytes');
  const missingStorage = centers.filter((c) => c.storageBytes == null).length;
  const potentialSample = sources.potential === 'sample';

  const tiles = [
    { testId: 'inventory-centers', sample: sources.centers === 'sample', label: 'Typing centers', value: formatCount(centers.length), sub: `${enabled} enabled · ${centers.length - enabled} disabled`, tooltip: 'All tenant records' },
    { testId: 'inventory-clients', sample: potentialSample, label: 'Clients', value: formatCount(sumKnown(centers, 'clients')), sub: 'client relationships', tooltip: 'Client records across centers. A company served by two centers counts twice.' },
    { testId: 'inventory-employees', sample: potentialSample, label: 'Client employees', value: formatCount(sumKnown(centers, 'employees')), sub: 'people managed for clients', tooltip: 'Unique people managed for linked clients. Not TC staff.' },
    { testId: 'inventory-staff', sample: sources.staff === 'sample', label: 'TC staff', value: formatCount(sumKnown(centers, 'staffCount')), sub: 'staff accounts', tooltip: 'Typing center staff, excluding platform and client portal users' },
    {
      testId: 'inventory-storage',
      sample: sources.storage === 'sample',
      label: 'Storage used',
      value: formatBytes(storage),
      sub: missingStorage ? `${missingStorage} center(s) not measured` : 'all centers measured',
      tooltip: `Sum per center; shared Main orgs may be counted twice until the dedup API ships.${storageComputedAt ? ` Snapshot ${new Date(storageComputedAt).toLocaleString()}` : ''}`,
    },
  ];

  return (
    // Mixed live + sample: each tile carries its own badge instead of the whole section.
    <Section title="Platform inventory">
      <Grid container spacing={1.5}>
        {tiles.map((t) => (
          <Grid item xs={6} sm={4} md key={t.label}>
            <KpiTile {...t} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default InventoryRow;
